import Workstreams from "@/components/Workstreams";

const FIELD_PHOTO =
  "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/s5a321dk_WhatsApp%20Image%202026-05-30%20at%208.54.52%20PM%20%284%29.jpeg";
const BRIEFING_PHOTO =
  "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/ccez06mq_WhatsApp%20Image%202026-05-30%20at%208.54.53%20PM%20%281%29.jpeg";

export default function About() {
  return (
    <div className="text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
          About ARTS
        </div>
        <h1
          className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] mb-10"
          style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
        >
          Born to redefine agriculture. <br />
          Built to <span className="text-[#2BA84A]">empower youth</span>.<br />
          Broadcast to inspire Nigeria.
        </h1>

        {/* Hero feature image */}
        <figure className="relative mb-16 border border-white/10 overflow-hidden">
          <img
            src={FIELD_PHOTO}
            alt="Agrovest Farm Hub site inspection — Niger State rice fields"
            className="w-full h-[420px] md:h-[520px] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
          <figcaption className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
            <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-2">
              Where it begins
            </div>
            <div
              className="text-2xl md:text-3xl font-bold tracking-tight max-w-2xl"
              style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
            >
              The Agrovest Farm Hub, Niger State, our 60-day stage for the next
              generation of Nigerian agri-preneurs.
            </div>
          </figcaption>
        </figure>

        <div className="grid md:grid-cols-2 gap-12 mt-4">
          <div className="space-y-6 text-white/70 leading-relaxed">
            <p>
              The Agrovest Reality TV Show (ARTS) is Nigeria's first and most
              ambitious agri-entertainment platform, a live residential
              agribusiness competition broadcast on Global TV and
              digital platforms.
            </p>
            <p>
              37 exceptional young Nigerians, one from each of Nigeria's 36
              states and the Federal Capital Territory, all between the ages of
              18 and 35, live and compete at the Agrovest Farm Hub for 60 days
              of farming, innovation, leadership and entrepreneurship challenges.
            </p>
            <p>
              Produced with the support of the Niger State Government, the Niger
              State Ministry of Agriculture, Sydani Group, Olohi Integrated
              Farms Limited, and the National Orientation Agency (NOA), ARTS is
              more than a TV show, it is a national movement.
            </p>
          </div>
          <div className="space-y-6">
            <figure className="relative overflow-hidden border border-white/10">
              <img
                src={BRIEFING_PHOTO}
                alt="Agrovest keynote address at launch press briefing"
                className="w-full h-64 object-cover"
                loading="lazy"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/40 to-transparent p-4 text-xs text-white/85">
                Keynote address · Agrovest Season 1 launch press briefing
              </figcaption>
            </figure>
            <div className="p-6 border border-white/10 bg-black/40">
              <div className="text-xs uppercase tracking-[0.25em] text-[#F26A1F] font-bold mb-3">
                Mission
              </div>
              <p className="text-white/70 leading-relaxed">
                To inspire, empower, and transform the next generation of
                Nigerian agripreneurs through agribusiness competition,
                empowerment, and television.
              </p>
            </div>
            <div className="p-6 border border-white/10 bg-black/40">
              <div className="text-xs uppercase tracking-[0.25em] text-[#1E8E3E] font-bold mb-3">
                Format
              </div>
              <p className="text-white/70 leading-relaxed">
                Live residential agribusiness competition, 60-day duration, 13
                broadcast episodes, scored by agricultural experts, business
                leaders, media professionals and Governor Bago AI.
              </p>
            </div>
            <div className="p-6 border border-white/10 bg-black/40">
              <div className="text-xs uppercase tracking-[0.25em] text-white/80 font-bold mb-3">
                Value Chain Coverage
              </div>
              <ul className="text-white/70 text-sm space-y-1">
                <li>· Seed selection &amp; soil preparation</li>
                <li>· Crop cultivation &amp; irrigation</li>
                <li>· Livestock breeding &amp; management</li>
                <li>· Agro-processing &amp; value addition</li>
                <li>· Market access &amp; sales strategy</li>
                <li>· Export &amp; offtake negotiations</li>
              </ul>
            </div>
          </div>
        </div>

        <section className="mt-24">
          <h2
            className="text-3xl md:text-4xl font-bold tracking-tighter mb-8"
            style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
          >
            Evaluation criteria
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              "Productivity",
              "Innovation",
              "Leadership",
              "Teamwork",
              "Agribusiness Knowledge",
              "Community Impact",
              "Financial Performance",
            ].map((c, i) => (
              <div
                key={c}
                className="p-5 border border-white/10 hover:border-[#F26A1F]/60 transition-colors"
              >
                <div className="text-xs text-[#F26A1F] font-bold mb-2">
                  0{i + 1}
                </div>
                <div className="font-bold tracking-tight">{c}</div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Workstreams full block */}
      <div className="border-t border-white/10 bg-[#0c0c0c]">
        <Workstreams />
      </div>
    </div>
  );
}
